import { render, staticRenderFns } from "./CardBalanceRedesign.vue?vue&type=template&id=7c5af195&scoped=true&"
import script from "./CardBalanceRedesign.vue?vue&type=script&lang=js&"
export * from "./CardBalanceRedesign.vue?vue&type=script&lang=js&"
import style0 from "./CardBalanceRedesign.vue?vue&type=style&index=0&id=7c5af195&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5af195",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardText,VCol,VDivider,VRow,VSpacer,VTooltip})
